// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"e4897e7d","453":"96a2cc12"}[chunkId] + ".chunk.js";
};